import { cloneElement } from 'react';

export const MessagePoll = (props) => {
  const { poll, children: element } = props;

  const data = poll
    ? {
        options: poll.options,
        title: poll.title,
        isVoted: poll.voted,
        votesNumber: poll.count,
      }
    : {};

  const pollElement = cloneElement(element, {
    ...data,
    ...element.props,
  });

  return poll ? pollElement : null;
};
